<template>
  <b-container fluid>
    <b-row class="min-vh-100 bg-dark">
      <b-col cols="12" lg="12" md="12" class="text-center my-auto mx-auto">
        <h1 class="text-white display-2">Josué Cámara</h1>
        <h1><span class="text-white">I'm <span class="text-muted">a</span></span> <span class="text-primary">software developer</span></h1>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'I\'m Josué Cámara a software developer who loves to build amazing things and learn about new technologies.'
    }]
  },
  data () {
    return {}
  }
}
</script>
